import { render, staticRenderFns } from "./NcpTableBody.vue?vue&type=template&id=54616c87&"
import script from "./NcpTableBody.vue?vue&type=script&lang=ts&"
export * from "./NcpTableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports